import { tableScrollMaxHeight } from '@/components/layout/layoutConstants';

const COLS = 9;

const HEADER_WIDTHS = ['w-14', 'w-20', 'w-16', 'w-12', 'w-20', 'w-24', 'w-16', 'w-14', 'w-16'];

const CELL_VARIANTS = [
  ['w-10', 'w-20', 'w-14', 'w-8', 'w-16', 'w-12', 'w-20', 'w-14', 'w-16'],
  ['w-12', 'w-16', 'w-10', 'w-12', 'w-10', 'w-16', 'w-14', 'w-10', 'w-16'],
  ['w-8', 'w-20', 'w-16', 'w-10', 'w-20', 'w-10', 'w-16', 'w-16', 'w-16'],
  ['w-14', 'w-16', 'w-12', 'w-8', 'w-14', 'w-14', 'w-10', 'w-12', 'w-16'],
  ['w-10', 'w-20', 'w-10', 'w-12', 'w-16', 'w-12', 'w-20', 'w-10', 'w-16'],
  ['w-12', 'w-16', 'w-14', 'w-10', 'w-10', 'w-16', 'w-12', 'w-14', 'w-16'],
];

/**
 * `headerHeight` comes from the page's `useHeaderHeight()` so the skeleton
 * occupies exactly the space the real table will, avoiding a layout jump when
 * data arrives.
 */
export function MediaPlanTableSkeleton({ headerHeight = 0 }: { headerHeight?: number }) {
  return (
    <div
      className="overflow-hidden animate-pulse"
      style={{ maxHeight: tableScrollMaxHeight(headerHeight) }}
    >
      {/* Header */}
      <div className="flex items-center gap-6 px-4 py-3 bg-slate-50 border-b border-slate-200">
        {HEADER_WIDTHS.map((w, i) => (
          <div key={i} className={`h-2.5 ${w} rounded-full bg-slate-200 flex-1`} />
        ))}
      </div>

      {/* Rows */}
      {Array.from({ length: 20 }).map((_, rowIdx) => {
        const variant = CELL_VARIANTS[rowIdx % CELL_VARIANTS.length];
        return (
          <div
            key={rowIdx}
            className="flex items-center gap-6 px-4 py-4 border-b border-slate-100 last:border-0"
          >
            {Array.from({ length: COLS }).map((_, colIdx) => (
              <div
                key={colIdx}
                className={`h-3.5 rounded bg-slate-100 flex-1 ${variant[colIdx]}`}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
}
